import * as v from "valibot";

import { rpcContract } from "../rpc";

export const createInfluencerAdminRpcContract = rpcContract({
  name: "createInfluencerAdmin",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.email("Invalid email address")),
    password: v.pipe(
      v.string(),
      v.minLength(6, "Password must be at least 6 characters long"),
      v.maxLength(128, "Password is too long"),
    ),
    handle: v.pipe(
      v.string(),
      v.minLength(3, "Handle must be at least 3 characters"),
      v.maxLength(64, "Handle must be at most 64 characters"),
      v.regex(/^[a-z0-9_\-.]+$/, "Handle can only contain lowercase letters, numbers, underscores, dots, and hyphens"),
    ),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    influencerId: v.string(),
    message: v.string(),
  }),
});

export type CreateInfluencerAdminParams = v.InferOutput<(typeof createInfluencerAdminRpcContract)["paramsSchema"]>;
export type CreateInfluencerAdminResult = v.InferOutput<(typeof createInfluencerAdminRpcContract)["resultSchema"]>;
